import {AfterRenderRef, AfterViewInit, Component, Input, OnInit, Signal} from '@angular/core';

declare global {
  interface Window {
    Trustpilot: any;
  }
}

@Component({
  selector: 'app-trustpilot',
  templateUrl: './trustpilot.component.html',
  styleUrls: ['./trustpilot.component.sass']
})
export class TrustpilotComponent implements OnInit, AfterViewInit {
  constructor() { }

  @Input() trustpilotTheme = 'light';
  @Input() trustpilotType = 'mini';
  @Input() displayClass = '';

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    const trustBoxRef = document.getElementById('trustbox');
    window.Trustpilot.loadFromElement(trustBoxRef);
  }
}
